export default __webpack_public_path__ + "static/media/Dashboard_Filled.af3a2735.svg";